import { setPictureInPictureModeConfig } from '../base/config/actions';
import { pinParticipant } from '../base/participants/actions';

import {
    CLEAR_REMOTE_ANNOTATIONS,
    SET_ANNOTATION_DRAWING,
    SET_REMOTE_ANNOTATION_ALLOWED
} from './actionTypes';

/**
 * Turns the local viewer's drawing mode on the large video on or off.
 *
 * @param {boolean} drawing - Whether the viewer is drawing.
 * @returns {Object}
 */
export function setAnnotationDrawing(drawing) {
    return {
        type: SET_ANNOTATION_DRAWING,
        drawing
    };
}

/**
 * Allows or forbids viewers to draw on the local participant's screen share.
 *
 * @param {boolean} allowed - Whether viewers may draw.
 * @returns {Object}
 */
export function setRemoteAnnotationAllowed(allowed) {
    return {
        type: SET_REMOTE_ANNOTATION_ALLOWED,
        allowed
    };
}

/**
 * Wipes what viewers drew on the local participant's screen share, for
 * everyone.
 *
 * @returns {Object}
 */
export function clearRemoteAnnotations() {
    return {
        type: CLEAR_REMOTE_ANNOTATIONS
    };
}

/**
 * Shows the local screen share on the large video and moves the meeting into
 * the floating Document Picture-in-Picture window, so a browser sharer who is
 * working in another window still sees where viewers draw. Must run from a
 * click: Document PiP needs a user gesture.
 *
 * @returns {Function}
 */
export function showLocalShareWithAnnotations() {
    return (dispatch, getState) => {
        const localShareId = getState()['features/base/mtApi'].localScreenShare?.id;

        localShareId && dispatch(pinParticipant(localShareId, true));
        dispatch(setPictureInPictureModeConfig(true));

        // After the stage switch has rendered: LargeVideo hides the local
        // share again whenever it newly lands on stage.
        setTimeout(() => window.dispatchEvent(new CustomEvent('show-my-screen-changed', { detail: true })));
    };
}
